import React from 'react';
import { BellRing, CheckCircle2, X } from 'lucide-react';

import { isSecondBiteReady } from '../../utils/demoState';
import './GuestSoftGateBanner.css';

/**
 * Compact top banner for guests who dismissed the save modal after completing
 * a study session. Replaces the prior generic soft-gate nudge.
 */
const GuestSoftGateBanner = ({ dueLabel, onSave, onExplore, onDismiss }) => {
  const secondBite = isSecondBiteReady();
  const headline = secondBite ? 'Your reviews are due.' : 'You finished your first snippet.';
  const subtext = secondBite
    ? 'Save your progress to see and complete them.'
    : !dueLabel || dueLabel === 'tomorrow'
      ? 'Your first review is tomorrow. Sign up free to keep your schedule.'
      : dueLabel === 'today'
        ? 'Your first review is later today. Save now so nothing resets.'
        : `Your first review lands ${dueLabel}. Save now so nothing resets.`;
  const LeadIcon = secondBite ? BellRing : CheckCircle2;

  return (
    <div
      className={[
        'demo-soft-gate-banner',
        secondBite ? 'demo-soft-gate-banner--second-bite' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      role="region"
      aria-label="Save your progress"
    >
      <div className="demo-soft-gate-banner__lead">
        <LeadIcon className="demo-soft-gate-banner__icon" size={20} strokeWidth={2} aria-hidden />
        <div className="demo-soft-gate-banner__copy">
          <strong className="demo-soft-gate-banner__headline">{headline}</strong>
          <span className="demo-soft-gate-banner__subtext">{subtext}</span>
        </div>
      </div>

      <div className="demo-soft-gate-banner__actions">
        <button
          type="button"
          className="demo-soft-gate-banner__btn demo-soft-gate-banner__btn--primary"
          onClick={onSave}
        >
          Save progress for free
        </button>
        {!secondBite && typeof onExplore === 'function' && (
          <button
            type="button"
            className="demo-soft-gate-banner__btn demo-soft-gate-banner__btn--secondary"
            onClick={onExplore}
          >
            Browse tracks
          </button>
        )}
        <button
          type="button"
          className="demo-soft-gate-banner__btn demo-soft-gate-banner__btn--ghost"
          onClick={onDismiss}
          aria-label="Dismiss"
        >
          <X size={16} strokeWidth={2} aria-hidden />
        </button>
      </div>
    </div>
  );
};

export default GuestSoftGateBanner;
